import { type IntegrationConnection } from './jira/connections';
import { type SupportedIntegrationProductSlugs } from '../../constants';
import { type OrNull } from '../../../../typings/utils';

export const filterConnectedIntegrationSlugs = (
  enabledIntegrationProductSlugs: SupportedIntegrationProductSlugs[],
  connections: OrNull<IntegrationConnection[]>
): SupportedIntegrationProductSlugs[] =>
  enabledIntegrationProductSlugs.filter(integration =>
    connections?.some(
      connection =>
        connection.product_slug === integration &&
        connection.status === 'connected'
    )
  );
